import React from 'react';
import { Instagram, Mail } from 'lucide-react';
import { footerSettings } from '@/hooks/useContent';

// TikTok icon as SVG since it's not in lucide-react
const TikTokIcon = () => (
  <svg 
    width="20" 
    height="20" 
    viewBox="0 0 24 24" 
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z"/>
  </svg>
);

const Footer = () => {
  const content = footerSettings;
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer-section py-12" style={{ backgroundColor: '#1e1919' }} data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
          {/* Brand */}
          <div className="md:col-span-1">
            <h3 className="text-2xl font-bold mb-4" style={{ color: '#8B7355' }}>
              Nibbled
            </h3>
            <p className="text-sm leading-relaxed" style={{ color: '#bbb5ae' }}>
              {content.tagline}
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-bold text-sm mb-4" style={{ color: '#f7f5f2' }}>
              Quick Links
            </h4>
            <ul className="space-y-2">
              <li>
                <button 
                  onClick={() => document.getElementById('services').scrollIntoView({ behavior: 'smooth' })}
                  className="text-sm hover:underline transition-all duration-200"
                  style={{ color: '#bbb5ae' }}
                  data-testid="footer-link-services"
                >
                  Services
                </button>
              </li>
              <li>
                <button 
                  onClick={() => document.getElementById('packages').scrollIntoView({ behavior: 'smooth' })}
                  className="text-sm hover:underline transition-all duration-200"
                  style={{ color: '#bbb5ae' }}
                  data-testid="footer-link-packages"
                >
                  Packages
                </button>
              </li>
              <li>
                <button 
                  onClick={() => document.getElementById('about').scrollIntoView({ behavior: 'smooth' })}
                  className="text-sm hover:underline transition-all duration-200"
                  style={{ color: '#bbb5ae' }}
                  data-testid="footer-link-about"
                >
                  About
                </button>
              </li>
              <li>
                <button 
                  onClick={() => document.getElementById('contact').scrollIntoView({ behavior: 'smooth' })}
                  className="text-sm hover:underline transition-all duration-200"
                  style={{ color: '#bbb5ae' }}
                  data-testid="footer-link-contact"
                >
                  Contact
                </button>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-bold text-sm mb-4" style={{ color: '#f7f5f2' }}>
              Our Services
            </h4>
            <ul className="space-y-2 text-sm" style={{ color: '#bbb5ae' }}>
              <li>Self-Service Cart</li>
              <li>Full-Service Experience</li>
              <li>Custom Packages</li>
              <li>Event Catering</li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-bold text-sm mb-4" style={{ color: '#f7f5f2' }}>
              Get in Touch
            </h4>
            <div className="space-y-3">
              <a 
                href={`mailto:${content.contact.email}`}
                className="flex items-center gap-2 text-sm hover:underline transition-all duration-200"
                style={{ color: '#bbb5ae' }}
                data-testid="footer-email"
              >
                <Mail size={16} />
                {content.contact.email}
              </a>
              <div className="flex gap-4 mt-4">
                <a 
                  href={content.social.instagram}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="social-icon p-2 hover:scale-110 transition-transform duration-200"
                  aria-label="Instagram"
                  style={{ display: 'inline-block', cursor: 'pointer' }}
                  data-testid="footer-instagram"
                >
                  <Instagram size={20} />
                </a>
                <a 
                  href={content.social.tiktok}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="social-icon p-2 hover:scale-110 transition-transform duration-200"
                  aria-label="TikTok"
                  style={{ display: 'inline-block', cursor: 'pointer' }}
                  data-testid="footer-tiktok"
                >
                  <TikTokIcon />
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div 
          className="pt-8 mt-8 text-center border-t"
          style={{ borderColor: '#736c64' }}
        >
          <p className="text-sm" style={{ color: '#bbb5ae' }}>
            © {currentYear} Nibbled. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
